import { FunctionComponent } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { SHARE_ROUTE, Sharing } from './sharing/Sharing';
import { SizeSelection } from './size-selection/SizeSelection';
import './Sidebar.scss';

export const Sidebar: FunctionComponent = () => {
  const navigate = useNavigate();

  const onClose = () => navigate('/');

  const isSharingActive = Boolean(useMatch({ path: SHARE_ROUTE, end: false }));
  const isSizeSelectionActive = Boolean(useMatch({ path: '/price', end: false }));

  return (
    <div className="sidebar">
      <Sharing active={isSharingActive} onClose={onClose} />
      <SizeSelection active={isSizeSelectionActive} onClose={onClose} />
    </div>
  );
};
